import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SessionTimeoutModal from '../session-timeout-modal/SessionTimeoutModal';
import SessionTimeoutPageTitle from '../session-timeout-page-title/SessionTimeoutPageTitle';

export class SessionTimeoutWarning extends PureComponent {

  static propTypes = {
    sessionExpiringAnnounced: PropTypes.bool,
  };

  static defaultProps = {
    sessionExpiringAnnounced: false,
  };

  render() {
    const {
      sessionExpiringAnnounced,
    } = this.props;

    if (!sessionExpiringAnnounced) {
      return null;
    }

    return (
      <React.Fragment>
        <SessionTimeoutModal />
        <SessionTimeoutPageTitle />
      </React.Fragment>
    );
  }
}

export default connect(state => ({
  sessionExpiringAnnounced: state.app.sessionExpiringAnnounced,
}))(SessionTimeoutWarning);
